module.exports = __webpack_public_path__ + "img/web.bda7057.png";